/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_isempty.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns true if the supplied geometry is empty.\nAn empty geometry is one that has no points, such as an empty geometry collection or an empty linestring.',
  examples: [
    'ROW point = TO_GEOPOINT("POINT(1.0 2.0)"),\n    empty_line = TO_GEOSHAPE("LINESTRING EMPTY"),\n    empty_polygon = TO_GEOSHAPE("POLYGON EMPTY")\n| EVAL pt_empty = ST_ISEMPTY(point),\n       line_empty = ST_ISEMPTY(empty_line),\n       polygon_empty = ST_ISEMPTY(empty_polygon)\n| KEEP pt_empty, line_empty, polygon_empty',
  ],
  params: {
    geometry: 'Expression of type `geo_point`, `geo_shape`, `cartesian_point` or `cartesian_shape`. If `null`, the function returns `null`.',
  },
};

export default docs;
